// frontend/src/components/KanbanTableroModal.jsx
import React from 'react';
import KanbanTablero from '../pages/KanbanTablero';
import './KanbanTableroModal.css';

/**
 * Componente que envuelve KanbanTablero en un modal a pantalla completa
 * Permite visualizar un tablero Kanban sin navegar a una nueva ruta
 */
const KanbanTableroModal = ({ boardId, onClose }) => {
  const handleBackgroundClick = (e) => {
    // Solo cerrar si se cliquea en el background, no en el contenido del modal
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="kanban-modal-overlay" onClick={handleBackgroundClick}>
      <div className="kanban-modal-content">
        {/* Botón de cerrar */}
        <button
          className="kanban-modal-close"
          onClick={onClose}
          title="Cerrar tablero (ESC)"
          aria-label="Cerrar"
        >
          ✕
        </button>

        {/* Contenido del tablero */}
        <div className="kanban-modal-body">
          <KanbanTablero boardId={boardId} onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

export default KanbanTableroModal;
